const preferredObjectValues = (value: any) => [
	value?.message,
	value?.error,
	value?.detail,
	value?.reason,
	value?.original,
	value?.data,
];

export const normalizeToastMessage = (
	value: unknown,
	fallback = 'Something went wrong',
	seen = new Set<any>(),
): string => {
	if (value instanceof Error) {
		return normalizeToastMessage(value.message, fallback, seen);
	}
	if (typeof value === 'string') {
		return value.trim() || fallback;
	}
	if (typeof value === 'number' || typeof value === 'boolean') {
		return String(value);
	}
	if (value === null || value === undefined) {
		return fallback;
	}
	if (seen.has(value)) {
		return fallback;
	}
	seen.add(value);
	if (Array.isArray(value)) {
		const messages = value
			.map((item) => normalizeToastMessage(item, '', seen))
			.filter((item) => item.trim());
		return messages.length ? messages.join(', ') : fallback;
	}
	if (typeof value === 'object') {
		for (const candidate of preferredObjectValues(value)) {
			if (candidate !== undefined && candidate !== value) {
				const normalized = normalizeToastMessage(candidate, '', seen);
				if (normalized.trim()) return normalized;
			}
		}
	}
	return fallback;
};
